
export const AllProjects = [
 
  {
    Sr: 1,
    img: '/images/Gurgaon-Faridabad.jpg',
    NameOfProject: "Ferojpur Jhirka Biwan",
    ScopeofWork: "Detail project Report",
    Client: "PWD B&R Haryana",
    Cost: "2919 Cr"
  },
  {
    Sr: 2,
    img: ' /images/Puranpur.jpg',
    NameOfProject: "Gurgaon-Faridabad, Ballabhgarh-Sohna",
    ScopeofWork: "Operations and Maintainnace",
    Client: "PWD B&R Branch, Gurgaon",
    Cost: "180.00 Cr.",
  },
  
  {
    Sr: 3,
    img:'',
    NameOfProject: "Hisar to Dabwali Section- NH10 (Pkg 1)",
    ScopeofWork: "Authority Engineer",
    Client: "NHAI",
    Cost: "549.00 Cr.",
  },
  {
    Sr: 4,
    img:'/images/Hisar-2.jpg',
    NameOfProject: "Hisar to Dabwali Section- NH10 (Pkg 2)",
    ScopeofWork: "Authority Engineer",
    Client: "NHAI",
    Cost: "648.00 Cr.",
  },
  {
    Sr: 5,
    img: '/images/sangrur-01.jpg',
    NameOfProject: "Sangrur Bypass to Tapa section | Tapa to Bathinda Section on NH607",
    ScopeofWork: "Authority Engineer",
    Client: "PWD B&R, Bathinda",
    Cost: "804.78 Cr.",
  },
  {
    Sr: 6,
    img: '',
    NameOfProject:
      "Nhavra- Namgaon- Kasti-Shrigonda-Adhalgaon-Jalgaon- Jamkhed, SH-55 (Pkg No. Nashik 4)",
    ScopeofWork: "Detailed Project Report",
    Client: "PWD Maharashtra",
    Cost: "3.25 Cr.",
  },
  {
    Sr: 7,
    img: '',
    NameOfProject: "Dwarka Expressway",
    ScopeofWork: "Feasibility Report",
    Client: "NHAI",
    Cost: "5,887.30 Cr.",
  },
  {
    Sr: 8,
    img: '/images/Jind-bhiwani.jpg',
    NameOfProject: "Pilibhit-Puranpur Section on NH730",
    ScopeofWork: "Authority Engineer",
    Client: "PWD Uttar Pradesh",
    Cost: "105.90 Cr.",
  },
  {
    Sr: 9,
    img: '/images/jind-karnal.jpg',
    NameOfProject: "Jind Karnal Section on NH352",
    ScopeofWork: "Authority Engineer",
    Client: "NHAI",
    Cost: "198.91 Cr.",
  },
  
];

export const Ongoing = [

  {
    Sr: 1,
    img: "/Home/Hero/Rafiabad.jpeg",
    NameOfProject: "RAFIABAD CHAMKOT",
    ScopeofWork: "AE",
    Client: "BRO",
    Cost: "473 Cr. ",
    Length:"51km",
    Status: "Running",
  },

  
  {
    Sr: 2,
    img: '/Home/Hero/Gondal.jpeg',
    NameOfProject: " JETPUR- GONDAL RAJKOT",
    ScopeofWork: "AE",
    Client: "NHAI",
    Cost: "1,205 Cr.",
    Length:"67.4km",
    Status: "Running",
  },

 
  {
    Sr: 3,
    img: '/Home/Hero/Dak3.jpeg',
    NameOfProject: "DAK SPUR",
    ScopeofWork: "AE",
    Client: "NHAI",
    Cost: "974 Cr.",
    Length:"16.9km",
    Status: "Running",
  },

  
  {
    Sr: 4,
    img: '/Home/Hero/samakhiyali.jpeg',
    NameOfProject: " SAMAKHIYALI SANTALPUR",
    ScopeofWork: "IE",
    Client: "NHAI",
    Cost: "1370.27 Cr.",
    Length:"90.9km",
    Status: "Running",
  },

  {
    Sr: 5,
    img: "/Home/Hero/Nashri.jpeg",
    NameOfProject: " NASHRI CHENANI ",
    ScopeofWork: "AE",
    Client: "NHAI",
    Cost: "431.37 Cr",
    Length:"39.100km",
    Status: "Running",
  },
  

  
  {
    Sr: 6,
    img: "/images/najibabad.jpg",
    NameOfProject: "PADHAR BIJNI ",
    ScopeofWork: "IE",
    Client: "NHAI",
    Cost: "545 Cr",
    Length:"19.050km",
    Status: "Running",
  },
 
 
];

export const CompletedProject = [
  {
    Sr: 1,
    img: '/images/Hisar-1.jpg',
    NameOfProject: " Hisar to Dabwali Package I ",
    ScopeofWork: "Construction Supervision",
    Client: "NHAI",
    Cost: "549 Cr",
    time: "July-2015 to Aug-2018",
  },
  {
    Sr: 2,
    img: '/images/Hisar-2.jpg',
    NameOfProject: "Hisar to Dabwali Package II",
    ScopeofWork: "Construction Supervision",
    Client: "NHAI",
    Cost: "648 Cr.",
    time: "Aug-2018 to Aug-2018",
  },
  {
    Sr: 3,
    img: '/images/sungrur-1.jpg',
    NameOfProject: " Sangrur Bypass",
    ScopeofWork: "Construction Supervision",
    Client: " PWD B&R, Bathinda",
    Cost: "804.78 Cr.",
    time: "Sep-2015 to Sep-2018",
  },
  {
    Sr: 4,
    img: '/images/Puranpur.jpg',
    NameOfProject: "Puranpur Khutar",
    ScopeofWork: "Construction Supervision",
    Client: "PWD UP",
    Cost: "143.39 Cr.",
    time: "Mar 2017 to Aug 2018",
  },
  {
    Sr: 5,
    img: '/images/jind-karnal.jpg',
    NameOfProject: "Jind-Karnal",
    ScopeofWork: "Construction Supervision",
    Client: "NHAI",
    Cost: "198.91 Cr",
    time: "Aug 2018 to Nov 2020",
  },
  {
    Sr: 6,
    img: '/images/Jind-bhiwani.jpg',
    NameOfProject: "Bhiwani-Mundal-Jind",
    ScopeofWork: "Construction Supervision",
    Client: "NHAI",
    Cost: "183.00 Cr",
    time: "Sept. 2018 to Oct. 2021",
  },
 
];
